<script setup lang="ts">
import { cn } from '@pokerly/ui';
import { onMounted, onUnmounted } from 'vue';
import { IconX } from '@tabler/icons-vue';

interface Props {
    open: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
    close: [];
}>();

function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
        emit('close');
    }
}

onMounted(() => {
    window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown);
});
</script>

<template>
    <transition name="modal-fade">
        <Teleport to="body">
            <div
                v-if="open"
                :class="
                    cn(
                        'absolute',
                        'bg-card-primary',
                        'text-card-card-foreground',
                        'right-6',
                        'top-40',
                        'max-w-100',
                        'min-w-80',
                        'z-99999',
                        'max-h-[80%]',
                        'overflow-auto',
                        'flex',
                        'flex-col',
                        'gap-4',
                        'p-6',
                        'rounded-lg',
                        'shadow-lg',
                        'border',
                        'border-border-default',
                    )
                "
                @click.stop
            >
                <div class="flex justify-between items-center">
                    <h4>Pokerly Dev Tools</h4>
                    <button class="close-button" @click="$emit('close')" title="Close"><IconX class="size-4" /></button>
                </div>
                <slot />
            </div>
        </Teleport>
    </transition>
</template>
